// Gatilho "resposta editada" (entidade service_order_reply) aceita SOMENTE "Atualizar Atividade" (`update_child_service_order`).
export const REPLY_EDITED_ENTITY = 'service_order_reply'
export const UPDATE_CHILD_ACTION = 'update_child_service_order'

// Entidades para as quais o back suporta a ação (UpdateChildServiceOrder.resolve_parent_service_order_id).
const UPDATE_CHILD_ENTITIES = ['service_order', 'event', REPLY_EDITED_ENTITY]

// Para as demais entidades/ações o resultado é o mesmo de antes (tudo permitido), exceto que a ação
// nova só aparece onde o back a suporta.
export const isActionAllowedForEntity = (action, entity) => {
  if (entity === REPLY_EDITED_ENTITY) return action === UPDATE_CHILD_ACTION
  if (action === UPDATE_CHILD_ACTION) return UPDATE_CHILD_ENTITIES.includes(entity)
  return true
}
